import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

/**
 * GuestRoute — inverse of ProtectedRoute.
 * Redirects authenticated users away from guest-only pages
 * (e.g. /login, /forgot-password, /reset-password, /register)
 * to the dashboard. Prevents the logic hole where a logged-in
 * user could still open the login / forgot-password screens.
 */
const GuestRoute = ({ children, redirectTo = '/dashboard' }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'var(--text-muted)',
        fontFamily: 'var(--font-mono)',
        fontSize: '0.9rem',
        paddingTop: '80px'
      }}>
        Loading...
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};

export default GuestRoute;
